// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"style_loadingText__1SVib"};